import { Box } from '@primer/react';
import { ReactNode, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { NotifyHelper } from '../../helpers/toast';
import { ImageIcon } from '@primer/octicons-react';
import { IUploadResult } from '../../models/response/upload/IUploadResult';
import { uploadApi } from '../../api/uploadApi';
import Text from '../ui/text';

interface IUploadProps {
    onUploadSuccess: (data: IUploadResult) => void,
    accept?: any,
    subFolder?: string,
    render?: () => ReactNode
}
const Upload = (props: IUploadProps) => {
    const [isUploading, setIsUploading] = useState(false);
    const accept: any = props.accept ? props.accept : {
        'image/*': [],
        'application/vnd.ms-excel': ['.xls', '.xlsx'],
        'application/pdf': [],
        'application/msword': ['.doc', '.docx'],
        'application/msg': ['.msg'],
    }
    // const defaultAccept = {
    //     'image/*': []
    // };
    // const accept = props.accept || defaultAccept;

    const onDrop = async (acceptedFiles: any) => {
        if (acceptedFiles.length > 0) {
            setIsUploading(true)
            const res = await uploadApi.uploadImages(acceptedFiles)
            setIsUploading(false)
            if (res.is_success) {
                props.onUploadSuccess(res.data)
            } else {
                NotifyHelper.Error(res.message ?? "Error")
            }
        }
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept

    })

    return (
        <Box>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                {props.render ? props.render() :
                    <Box sx={{
                        p: 3,
                        textAlign: "center",
                        borderStyle: "dashed",
                        borderWidth: "1px",
                        borderColor: "border.default",
                        borderRadius: 2,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        color: "fg.muted",
                        '&:hover': {
                            borderColor: 'accent.fg',
                            color: 'accent.fg'
                        }
                    }}>
                        {isUploading ? (
                            <Text text='Đang tải lên...' />
                        ) : (
                            <>
                                <ImageIcon size={24} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Text text='Kéo thả vào đây hoặc' />
                                    <Text text='Nhấn để chọn' />
                                </Box>
                            </>
                        )}
                    </Box>
                }
            </div>
        </Box>
    );
};

export default Upload;